import { useState } from 'react'

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import CheckIcon from '@mui/icons-material/Check'
import { Chip as MuiChip, Stack, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

/**
 * UI control
 */
export default function XlsTabs() {
	const { control } = useFormContext()

	return (
		<Controller
			name="exportContents"
			control={control}
			render={({ field: { onChange, value } }) => <XlsTabsUI value={value} onChange={onChange} />}
		/>
	)
}

/**
 * Presentational component
 */
export function XlsTabsUI({ value, onChange }: { value: string[]; onChange: (value) => void }) {
	const [currentValue, setCurrentValue] = useState<string[]>(value)

	const handleChange = (key) => {
		if (currentValue.includes(key)) {
			// Remove the key if it already exists
			const newValue = currentValue.filter((i) => i !== key)
			setCurrentValue(newValue)
			onChange(newValue)
			return
		}

		// Add the key if it doesn't exist
		const newValue = [...currentValue, key]
		setCurrentValue(newValue)

		// Call the onChange function with the new value
		onChange(newValue)
	}

	return (
		<Stack spacing={2} alignItems="align-start" direction="row">
			<Typography variant="body1">Include Workbook Tabs</Typography>
			<Stack spacing={2} alignItems="align-start">
				<Chip
					label="MFR Summary"
					id="MFR_SUMMARY"
					value={currentValue.some((i) => i === 'MFR_SUMMARY')}
					onChange={handleChange}
				/>
				<Chip
					label="Contract Details"
					id="CONTRACT_DETAILS"
					value={currentValue.some((i) => i === 'CONTRACT_DETAILS')}
					onChange={handleChange}
				/>
				<Chip
					label="Item Details"
					id="ITEM_DETAILS"
					value={currentValue.some((i) => i === 'ITEM_DETAILS')}
					onChange={handleChange}
				/>
				<Chip
					label="Settings"
					id="SETTINGS"
					value={currentValue.some((i) => i === 'SETTINGS')}
					onChange={handleChange}
				/>
				<Chip
					label="Glossary"
					id="GLOSSARY"
					value={currentValue.some((i) => i === 'GLOSSARY')}
					onChange={handleChange}
				/>
			</Stack>
		</Stack>
	)
}

/**
 * Displays a chip for a value
 */
function Chip({
	label,
	id,
	value,
	onChange,
}: {
	label: string
	id: string
	value: boolean
	onChange: (key: string) => void
}) {
	return (
		<MuiChip
			label={label}
			size="small"
			color={value ? 'success' : 'default'}
			icon={value ? <CheckIcon /> : <CancelOutlinedIcon />}
			onClick={() => onChange(id)}
		/>
	)
}
